import React, { FC } from "react";
import Image from "next/image";
import styles from "../../../styles/common/PrimaryButtonProfile.module.scss";
import { IAccountButtonProps } from "../../../models/account";

const getClassNameSectionButton = (
    disabled: boolean,
    isPrimary: boolean,
    isActive: boolean,
    isSubPrimary: boolean
) => {
    if (disabled) {
        return styles.containerSecondary;
    }

    if (isPrimary) {
        return styles.containerPrimary;
    }

    if (isSubPrimary && isActive) {
        return styles.containerSubPrimaryActive;
    }

    if (isSubPrimary) {
        return styles.containerSubPrimary;
    }

    return "";
};

const SectionButton: FC<IAccountButtonProps> = props => {
    const {
        icon,
        iconDeactivated,
        title,
        onClick,
        id,
        isPrimary,
        isSubPrimary,
        isActive,
        disabled,
    } = props;

    return (
        <div
            className={getClassNameSectionButton(
                disabled,
                isPrimary,
                isActive,
                isSubPrimary
            )}
            onClick={() => !disabled && onClick(id)}
        >
            {disabled ? (
                <>
                    <Image
                        src={`/images/${iconDeactivated}`}
                        alt={title}
                        height={20}
                        width={20}
                    />
                    <span>{title}</span>
                </>
            ) : (
                <>
                    <Image
                        src={`/images/${icon}`}
                        alt={title}
                        height={20}
                        width={20}
                    />
                    <span>{title}</span>
                </>
            )}
        </div>
    );
};

export default SectionButton;
